import React, { useMemo } from "react";
import AddAboutMe from "./Forms/AddAboutMe";
import AddEducation from "./Forms/AddEducation";
import AddBackgroundVerifications from "./Forms/AddBackgroundVerifications";
import AddSkills from "./Forms/AddSkills";
import AddEquipments from "./Forms/AddEquipments";
import AddLanguage from "./Forms/AddLanguage";
import AddLicenseCertifications from "./Forms/AddLicenseCertifications";
import AddEmployment from "./Forms/AddEmployment";

const ProfileDetails = ({ userData, refetchMe, qualificationTypeMap }) => {
  return (
    // Every section below adds or edits through its own pencil, plus and bin icons.
    // A submitted profile hides them all in one place rather than threading a flag
    // through nine near-identical sections.
    <div>
      {/* Profile picture is uploaded from the header avatar, so it's hidden here. */}
      <AddAboutMe description={userData?.description} refetchMe={refetchMe} />
      <AddLanguage />
      <AddEducation userId={userData?.id} />
      <AddBackgroundVerifications
        userId={userData?.id}
        backgroundCheckId={qualificationTypeMap["background check"]}
      />
      {/* <AddTypeOfWork /> */}
      <AddEquipments userId={userData?.id} equipmentId={qualificationTypeMap["equipment"]} />
      <AddLicenseCertifications
        userId={userData?.id}
        licencesId={qualificationTypeMap["licences"]}
        certificationId={qualificationTypeMap["certification"]}
      />
      <AddSkills userId={userData?.id} />
      <AddEmployment userId={userData?.id} />
    </div>
  );
};

export default ProfileDetails;
